import { render, staticRenderFns } from "./MapInfographic.vue?vue&type=template&id=f9515782&"
import script from "./MapInfographic.vue?vue&type=script&lang=js&"
export * from "./MapInfographic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports